import React from 'react'
import {Trans, useTranslation} from '@modifi/plugin-i18n'
import {CustomerDialogButtonRow, P, H5, Strong} from '@modifi/ui'
import {EXPECTED_FINANCING_LIMIT_CAP} from '../../constants'

export type LimitConfirmationDialogProps = {
  params: {
    limitAmount?: string
    submitTradePartner: () => void
  }
  savePending: boolean
  closeDialog: () => void
}

const LimitConfirmationDialog: React.FC<LimitConfirmationDialogProps> = ({
  params,
  savePending,
  closeDialog,
}) => {
  const {limitAmount, submitTradePartner} = params
  const {t} = useTranslation('charon')

  return (
    <>
      <H5 textAlign="center">{t('dialog.seller-trade-partner.limit-confirmation.headline')}</H5>
      <P textAlign="center" my={24}>
        <Trans
          i18nKey={`dialog.seller-trade-partner.limit-confirmation.${
            limitAmount && +limitAmount > EXPECTED_FINANCING_LIMIT_CAP.high ? 'high' : 'medium'
          }-amount.description`}
          components={[<Strong />]}
          t={t}
          values={{limitAmount}}
        />
      </P>
      <CustomerDialogButtonRow
        loading={savePending}
        expectedSubmitDuration={2000}
        canSubmit={!savePending}
        onSubmitClick={submitTradePartner}
        submitText={t('dialog.seller-trade-partner.limit-confirmation.cta-submit', {limitAmount})}
        hasCancel
        canCancel={!savePending}
        onCancelClick={closeDialog}
      />
    </>
  )
}

export default LimitConfirmationDialog
